import { IReportState } from "../../report/states.store";
import { MutationTree } from "vuex";
import ReportStoreTypes from "./define-types.store";
import {
  NotificationModel
} from "../../../models/report";

const checkSendMessagStatusMutations: MutationTree<IReportState> = <MutationTree<
  IReportState
>>{

  /** STORE NEW SESSION TO STATE */
  [ReportStoreTypes.Set.ADD_NOTIFICATIONS]: (
    state: IReportState,
    notification: NotificationModel
  ) => {
    if (!state.reportNotification) return;
    state.reportNotification.push(notification);
  },

  /** REMOVE NEW SESSION TO STATE */
  [ReportStoreTypes.Set.REMOVE_NOTIFICATIONS]: (
    state: IReportState,
    notification: NotificationModel
  ) => {
    if (!state.reportNotification) return;
    let index = state.reportNotification.indexOf(notification)
    state.reportNotification.splice(index, 1);
  },
};

export default checkSendMessagStatusMutations;
